module.exports = __webpack_public_path__ + "static/media/37-7.a93eb4fa.mp3";